<div class="container-fluid">

  <div>
    <div class="margin-top-8">
      <div class="header">
        {{!editing ? ( 'bikeshop.coupons.add_coupon' | translate ) : ( 'bikeshop.coupons.edit_coupon' | translate)}}
      </div>
      <div class="coupon_description">
        {{ 'bikeshop.coupons.coupon_description' | translate }}
      </div>

    </div>
    <div class="margin-top-8 info-container content">
      <p-progressSpinner *ngIf="loading || loadingLookupData" [style]="{ width: '30px', height: '30px' }"
                         strokeWidth="2" fill="transparent" animationDuration=".5s"></p-progressSpinner>

      <div class="header-container" *ngIf="!loading && !editing && isWorkshop">
        <div class="page-header" style="background-color: rgba(137, 143, 161, 0.1); padding: 18px 0px 18px 18px; margin: 0px 0px 0px 0px; ">
          <span class="link-title" [ngClass]="{'selected': tab===0}" (click)="changeTab(0)"
                style="margin-right: 50px;">Create Coupon</span>
          <span [ngClass]="{'selected': tab===1}" class="link-title" (click)="changeTab(1)"
                style="margin-right: 50px;">{{'general.import' | translate}}</span>
        </div>
      </div>

      <div *ngIf="!loading && tab==0">
        <div class="row margin-top-8" *ngIf="partner.ParentID">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.can_be_used_with_any_store' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="linkedToParent" [disabled]="expired" (onChange)="parentToggled()"></p-inputSwitch>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label" [ngClass]="{'red bold': couponExists}">
            {{ 'bikeshop.coupons.coupon_code' | translate }}
          </div>
          <div class="col-md-8 value">
            <input id="float-input" type="text" pInputText [disabled]="editing"
                   placeholder="{{ 'bikeshop.coupons.coupon_code_placeholder' | translate }}" [(ngModel)]="coupon.couponCode"
                   (ngModelChange)="coupon.couponCode = $event.toUpperCase()" (keydown)="inputChanged()" (focus)="editingCouponCode = true" (blur)="editingCouponCode = false" />
            <div class="small" *ngIf="couponExists">{{ 'bikeshop.coupons.coupon_code_exists' | translate }}</div>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isWorkshop">
          <div class="col-md-4 label"
               [ngClass]="{'red bold': coupon.redeemMethod === undefined || coupon.redeemMethod.length === 0}">
            *{{ 'bikeshop.coupons.redeem_method' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-dropdown [options]="redeemMethodOptions" [(ngModel)]="coupon.redeemMethod" [disabled]="expired">
            </p-dropdown>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label" [ngClass]="{'red bold': coupon.type === undefined || coupon.type.length === 0}">
            *{{ 'bikeshop.coupons.type' | translate }}
          </div>
          <div class="col-md-8 value">
            <div *ngIf="!isRentals">
              <p-radioButton name="type" value="FIXED_VALUE" label="{{ 'bikeshop.coupons.fixed_value' | translate }}"
                             [disabled]="expired" [(ngModel)]="coupon.type"></p-radioButton>
            </div>
            <div style="margin-top: 4px">
              <p-radioButton name="type" value="PERCENT" label="{{ 'bikeshop.coupons.percent' | translate }}"
                             [disabled]="expired" [(ngModel)]="coupon.type"></p-radioButton>
            </div>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isLightSpeed">
          <div class="col-md-4 label"
               [ngClass]="{'red bold': coupon.lightSpeedDiscountID === null || coupon.lightSpeedDiscountID === undefined || coupon.lightSpeedDiscountID.length === 0}">
            *{{ 'bikeshop.coupons.lightspeed_discount' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-dropdown [options]="getLightSpeedDiscountOpitons()" [(ngModel)]="coupon.lightSpeedDiscountID" placeholder="{{'bikeshop.coupons.select_a_discount' | translate }}" [disabled]="expired || lightSpeedDiscountOpitons.length === 0" (onChange)="lightSpeedDiscountSelected($event)">
            </p-dropdown>
          </div>
        </div>

        <div class="row margin-top-8" *ngIf="coupon.type === 'PERCENT' && !isLightSpeed">
          <div class="col-md-4 label"
               [ngClass]="{'red bold': coupon.percentValue === null || coupon.percentValue === undefined || coupon.percentValue.length === 0}">
            *{{ 'bikeshop.coupons.percent' | translate }}
          </div>
          <div class="col-md-3 value">
            <div class="p-inputgroup">
              <input type="number" pInputText [(ngModel)]="coupon.percentValue" [disabled]="expired || isLightSpeed" />
              <span class="p-inputgroup-addon">%</span>
            </div>
          </div>
        </div>

        <div class="row margin-top-8" *ngIf="coupon.type === 'FIXED_VALUE' && !isLightSpeed">
          <div class="col-md-4 label"
               [ngClass]="{'red bold': coupon.fixedValue === null || coupon.fixedValue === undefined || coupon.fixedValue.length === 0}">
            *{{ 'bikeshop.coupons.fixed_value' | translate }}
          </div>
          <div class="col-md-3 value">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">{{partner.CurrencySymbol}}</span>
              <input type="number" pInputText [(ngModel)]="coupon.fixedValue" [disabled]="expired || isLightSpeed" />
            </div>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.coupon_description_input' | translate }}
          </div>
          <div class="col-md-8 value">
            <input id="float-input" type="text" pInputText [disabled]="expired"
                   [(ngModel)]="coupon.description" />
            <small>{{ 'bikeshop.coupons.coupon_description_placeholder' | translate }}</small>
          </div>
        </div>

        <hr>
        <div class="row margin-top-16" *ngIf="isWorkshop">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_users' | translate }}
          </div>
          <div class="col-md-4 value">
            <p-inputSwitch [(ngModel)]="coupon.linkedToUser" [disabled]="expired"></p-inputSwitch>
          </div>
          <div class="col-md-4" *ngIf="coupon.linkedToUser && !showAddUser" style="display:flex">
            <div style="margin-left: auto;">
              <button pButton (click)="showAddUser = true" class="p-mini"
                      label="{{'bikeshop.coupons.link_user' | translate}}"></button>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showAddUser">
          <div class="col-md-12">
            <div class="add-user">
              <app-cyclist [partnerId]="partner.ID" user="{}" (update)="addUser($event)" [nextCyclist]="null"
                           [messageService]="messageService"></app-cyclist>
              <div class="close-button"><span class="fa fa-times" (click)="showAddUser = false"></span></div>
            </div>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="coupon.linkedToUser && !loading && !showAddUser">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_customers' | translate }}
          </div>
          <div class="col-md-8 value">
            <div class="user bold margin-top-16" *ngIf="coupon.linkedUsers && coupon.linkedUsers.length > 0">
              <div class="name">{{ 'general.headers.name' | translate }}</div>
              <div class="email">{{ 'general.headers.email' | translate }}</div>
              <div class="phonenumber">{{ 'general.headers.phone_number' | translate }}</div>
              <div class="action"></div>
            </div>
            <div *ngFor="let user of coupon.linkedUsers; let i = index;" class="user">
              <div class="name">{{user.name}} {{user.surname}}</div>
              <div class="email">{{user.email}}</div>
              <div class="phonenumber">{{user.phoneNumber}}</div>
              <div class="action"><span class="fa fa-times-circle" (click)="removeUser(i)"></span></div>
            </div>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isWorkshop">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.only_for_first_time_clients' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.forNewClientsOnly" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isWorkshop">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_service_types' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.linkToServiceTypes" [disabled]="expired || linkedToParent"></p-inputSwitch>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="coupon.linkToServiceTypes && !loadingLookupData && !loading">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_service_types' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-multiSelect [options]="serviceTypes" [(ngModel)]="selectedServiceTypes" [filter]="true"
                           [showToggleAll]="false" defaultLabel="{{ 'general.choose' | translate}}">
            </p-multiSelect>
            <small>{{ 'bikeshop.coupons.coupon_service_types_info' | translate }}</small>
          </div>
        </div>


        <div class="row margin-top-16" *ngIf="isWorkshop">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_product_categories' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.linkedToProductCategories" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="coupon.linkedToProductCategories && !loadingLookupData && !loading">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_product_categories' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-multiSelect [options]="productCategories" [(ngModel)]="selectedProductCategories" optionLabel="label"
            filterBy="label"
                           defaultLabel="{{ 'general.choose' | translate}}">
            </p-multiSelect>
            <small>{{ 'bikeshop.coupons.coupon_product_category_info' | translate }}</small>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isRentals">
          <div class="col-md-4 label" [ngClass]="{'red': !coupon.applyToRentalProducts && !coupon.applyToRentalAccessories}">
            {{ 'bikeshop.coupons.apply_to_rental_products' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.applyToRentalProducts" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isRentals && coupon.applyToRentalProducts">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_rental_categories' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.linkedToRentalCategories" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>        
        <div class="row margin-top-8" *ngIf="coupon.applyToRentalProducts && coupon.linkedToRentalCategories && !loadingLookupData && !loading">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_product_categories' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-multiSelect [options]="rentalCategories" [(ngModel)]="selectedRentalCategories" [filter]="true"
                           [showToggleAll]="false" defaultLabel="{{ 'general.choose' | translate}}">
            </p-multiSelect>            
            <small>{{'bikeshop.coupons.linked_rental_categories_info' | translate}}</small>
          </div>
        </div>

        
        <div class="row margin-top-16" *ngIf="isRentals">
          <div class="col-md-4 label" [ngClass]="{'red': !coupon.applyToRentalProducts && !coupon.applyToRentalAccessories}">
            {{ 'bikeshop.coupons.apply_to_rental_accessories' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.applyToRentalAccessories" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isRentals && coupon.applyToRentalAccessories">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_rental_accessory_categories' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.linkedToRentalAccessoryCategories" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="coupon.applyToRentalAccessories && coupon.linkedToRentalAccessoryCategories && !loadingLookupData && !loading">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_rental_accessory_categories' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-multiSelect [options]="rentalAccessoryCategories" [(ngModel)]="selectedRentalAccessoryCategories" [filter]="true"
                           [showToggleAll]="false" defaultLabel="{{ 'general.choose' | translate}}">
            </p-multiSelect>            
            <small>{{'bikeshop.coupons.linked_rental_accessory_categories_info' | translate}}</small>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isRentals">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_rental_affiliates' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.linkToAffiliates" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="coupon.linkToAffiliates && !loadingLookupData && !loading">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_rental_affiliates' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-multiSelect [options]="affiliates" [(ngModel)]="selectedRentalAffiliates" [filter]="true"
                           [showToggleAll]="false" defaultLabel="{{ 'general.choose' | translate}}">
            </p-multiSelect>     
            <small>{{'bikeshop.coupons.linked_rental_affiliates_info' | translate}}</small>       
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isRentals">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_to_specific_days' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-inputSwitch [(ngModel)]="coupon.specifySpecificDays" [disabled]="expired"></p-inputSwitch>
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="coupon.specifySpecificDays && !loadingLookupData && !loading">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.linked_specific_days' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-multiSelect [options]="specificDays" [(ngModel)]="selectedRentalDays" [filter]="false" optionLabel="dayOfWeekName" optionValue="dayOfWeek" defaultLabel="{{ 'general.choose' | translate}}">
            </p-multiSelect>     
            <small>{{'bikeshop.coupons.linked_specific_days_info' | translate}}</small>       
          </div>
        </div>

        <hr>
        <div class="row margin-top-8">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.limit_date' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-checkbox [binary]="true" [(ngModel)]="limitDate" [disabled]="expired"></p-checkbox>
          </div>
        </div>
        <div class="row margin-top-16" *ngIf="limitDate">
          <div class="col-md-4 label" [ngClass]="{'red bold': coupon.expiryDate === null || coupon.expiryDate === ''}">
            *{{ 'bikeshop.coupons.expiry_date' | translate }}
          </div>
          <div class="col-md-8 value">
            <p-calendar [(ngModel)]="coupon.expiryDate" dateFormat="{{countryData.DatePickerFormat}}" [disabled]="expired"></p-calendar>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.limit_usage' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-checkbox [binary]="true" [(ngModel)]="limitUsage" [disabled]="expired"></p-checkbox>
          </div>
        </div>
        <div class="row margin-top-16" *ngIf="limitUsage">
          <div class="col-md-4 label"
               [ngClass]="{'red bold': coupon.usageTimes === null || coupon.usageTimes === '' || coupon.usageTimes <= 0}">
            *{{ 'bikeshop.coupons.usage_times' | translate }}
          </div>
          <div class="col-md-3 value">
            <div class="p-inputgroup">
              <input type="number" pInputText [(ngModel)]="coupon.usageTimes" [disabled]="expired" />
              <span class="p-inputgroup-addon">{{coupon.usageTimes === 1 ? 'time' : 'times' }}</span>
            </div>
          </div>
        </div>
        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.coupons.limit_customer_usage' | translate }}
          </div>
          <div class="col-md-2 value">
            <p-checkbox [binary]="true" [(ngModel)]="coupon.limitUsagePerCustomer" [disabled]="expired"></p-checkbox>
          </div>
        </div>


        <div class="row margin-top-16" *ngIf="isRentals">
          <div class="col-md-4 label" [ngClass]="{'red': coupon.numberRentalProductsToQualify < 0 || coupon.numberRentalProductsToQualify === null}">
            {{ 'bikeshop.coupons.min_rental_products' | translate }}
          </div>
          <div class="col-md-3 value">
            <div class="p-inputgroup">
              <input type="number" pInputText [(ngModel)]="coupon.numberRentalProductsToQualify" [disabled]="expired" />
            </div>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isRentals">
          <div class="col-md-4 label" [ngClass]="{'red': coupon.minimumRentalSpendToQualify < 0 || coupon.minimumRentalSpendToQualify === null}">
            {{ 'bikeshop.coupons.min_rental_spend' | translate }}
          </div>
          <div class="col-md-3 value">
            <div class="p-inputgroup">
              <input type="number" pInputText [(ngModel)]="coupon.minimumRentalSpendToQualify" [disabled]="expired" />
            </div>
          </div>
        </div>

        <hr>

        <div class="row margin-top-16" *ngIf="expired">
          <div class="col-md-12 expired">{{ 'bikeshop.coupons.expired' | translate }}</div>
        </div>
        <div class="row margin-top-16" *ngIf="!expired && !loading && !loadingLookupData && !showAddUser">
          <div class="col-md-4">
            <button *ngIf="coupon.id" pButton (click)="expireCoupon()"
                    class="p-button-raised alternate full-width" label="{{'bikeshop.coupons.expire_coupon' | translate}}"
                    [disabled]="saving || loading"></button>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <button pButton (click)="save()" class="p-button-raised full-width"
                    label="{{'bikeshop.general.save' | translate}}" [disabled]="saving || loading || !valid() || editingCouponCode"></button>
          </div>

        </div>
      </div>

      <div *ngIf="!loading && tab==1" style="padding-top: 25px">

        <div class="container-fluid">


          <div class="flex">
            <div class="wizard">
              <ul>
                <li>
                  <a class="first">
                    <span class="wizard-step" [ngClass]="{'active': step===1, 'complete' : step > 1}">
                      <span [ngClass]="{'inner-circle':step === 1}"></span>
                      <span [ngClass]="{'hide':step > 1}"></span>
                    </span>
                    <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">
                      {{
              'bikeshop.service_imports.step1' | translate
                      }}
                    </span>
                  </a>
                </li>
                <li>
                  <a>
                    <span class="wizard-step" [ngClass]="{'active': step===2, 'complete' : step > 2}">
                      <span [ngClass]="{'inner-circle':step === 2}"></span>
                      <span [ngClass]="{'hide':step > 2}"></span>
                    </span>
                    <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">
                      {{
              'bikeshop.service_imports.step2' | translate
                      }}
                    </span>
                  </a>
                </li>
                <li class="last">
                  <a>
                    <span class="wizard-step" [ngClass]="{'active': step===3}">
                      <span [ngClass]="{'inner-circle':step === 3}"></span>
                      <span [ngClass]="{'hide':step > 3}"></span>
                    </span>
                    <span class="wizard-title" [ngClass]="{'active': step===3, 'complete' : step > 2}">
                      {{
              'bikeshop.service_imports.step3' | translate
                      }}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="invalidFileFormat" class="validation-issues">{{ "bikeshop.service_imports.invalid_file_format" | translate }}</div>

          <div class="margin-top-16 content download-container" *ngIf="step === 1" style=" width: 50%; left: 25%; right: 25%;">
            <div>
              <div>
                <a href="/assets/excel-templates/Coupons Import Template.xlsx" target="_blank" download="Coupons Import Template.xlsx">
                  <button pButton class="full-width"
                          label="{{ 'bikeshop.service_imports.download_template' | translate }}"></button>
                </a>
              </div>
              <div class="margin-top-16">
                <button pButton class="full-width accent"
                        label="{{ 'bikeshop.service_imports.select_file' | translate }}" (click)="fileUpload.click()"></button>
                <input #fileUpload type="file" accept=".xlsx" style="display: none;" (change)="prepareFile($event)">
              </div>
            </div>
          </div>

          <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 2">
            <div class="validation-issues" *ngIf="hasValidationErrors">
              {{ 'bikeshop.service_imports.has_validation_errors' | translate }}
            </div>



            <p-table #couponsTable [columns]="columns" [value]="sheetData">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [ngStyle]="{'width': col.field === 'partner' ? '220px' : 'auto'}">
                    {{ col.header }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-coupon let-columns="columns">
                <tr [pSelectableRow]="coupon">
                  <td *ngFor="let col of columns" [ngClass]="{'bold' : col.field === 'couponCode'}">
                    <div *ngIf="col.field !== 'status'">
                      {{
                    col.type === 'date' ? (coupon[col.field] === null ? '-' : (coupon[col.field] | date : 'yyyy-MM-dd') ) :
                    coupon[col.field]
                      }}
                    </div>
                    <div *ngIf="col.field === 'status'">
                      <i *ngIf="coupon[col.field]=='Valid'" class="fa fa-check-square-o" style="color: var(--green)"></i>
                      <i *ngIf="coupon[col.field]=='Invalid'" class="fa fa-times" style="color: var(--red)"></i>

                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 3">



            <p-table #couponsTable [columns]="columns" [value]="sheetData">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [ngStyle]="{'width': col.field === 'partner' ? '220px' : 'auto'}">
                    {{ col.header }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-coupon let-columns="columns">
                <tr [pSelectableRow]="coupon">
                  <td *ngFor="let col of columns" [ngClass]="{'bold' : col.field === 'couponCode'}">
                    <div *ngIf="col.field !== 'status'">
                      {{
                    col.type === 'date' ? (coupon[col.field] === null ? '-' : (coupon[col.field] | date : 'yyyy-MM-dd') ) :
                    coupon[col.field]
                      }}
                    </div>
                    <div *ngIf="col.field === 'status'">
                      <i *ngIf="coupon[col.field]=='Valid'" class="fa fa-check-square-o" style="color: var(--success)"></i>
                      <i *ngIf="coupon[col.field]=='Invalid'" class="fa fa-times" style="color: var(--danger)"></i>
                      <i *ngIf="coupon[col.field]=='Importing'" class="fa fa-cloud-upload" style="color: var(--info)"></i>
                      <i *ngIf="coupon[col.field]=='Imported'" class="fa fa-cloud-upload" style="color: var(--success)"></i>

                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="margin-bottom-16">
              <p-progressBar [value]="progress" [showValue]="false"></p-progressBar>
            </div>

          </div>

        </div>

        <div class="bottom-sheet" *ngIf="step == 2">
          <div class="flex">

            <div style="flex:1">
            </div>

            <div class="right flex">
              <button pButton class="full-width alternate" (click)="resetWizard()"
                      label="{{ 'bikeshop.service_imports.reset_wizard' | translate }}"></button>
              <div style="min-width: 200px;margin-left: 32px">
                <button pButton class="full-width accent" (click)="beginImport()"
                        label="{{ 'bikeshop.service_imports.begin_import' | translate }}"></button>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom-sheet" *ngIf="step == 3">
          <div class="flex">
            <div class="right flex">
              <button pButton class="full-width alternate" (click)="resetWizard()"
                      label="{{ 'bikeshop.service_imports.import_another_file' | translate }}"></button>
            </div>
          </div>
        </div>

      </div>
      <div class="margin-top-16 info-container content" *ngIf="coupon.usage && coupon.usage.length > 0">
        <div class="margin-top-16">
          <p-table #couponsUsageTable [columns]="columns" [value]="coupon.usage">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.field === 'partner' ? '220px' : 'auto'}">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-coupon let-columns="columns">
              <tr [pSelectableRow]="coupon">
                <td *ngFor="let col of columns" [ngClass]="{'bold' : col.field === 'couponCode'}">
                  <div>
                    {{
                    col.type === 'date' ? (coupon[col.field] === null ? '-' : (coupon[col.field] | date : 'yyyy-MM-dd') ) :
                    coupon[col.field]
                    }}
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

    </div>
</div>
<p-confirmDialog key="add_edit_coupons"></p-confirmDialog>
